"use strict";

var _regeneratorRuntime = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameRegistryState = void 0;

var web3_js_1 = require("@solana/web3.js");

var borsh_1 = require("borsh");

var NameRegistryState = /*#__PURE__*/function () {
  function NameRegistryState(obj) {
    _classCallCheck(this, NameRegistryState);

    this.parentName = new web3_js_1.PublicKey(obj.parentName);
    this.owner = new web3_js_1.PublicKey(obj.owner);
    this.class = new web3_js_1.PublicKey(obj.class);
  }

  _createClass(NameRegistryState, null, [{
    key: "retrieve",
    value: function () {
      var _retrieve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection, nameAccountKey) {
        var _a, nameAccount, res;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return connection.getAccountInfo(nameAccountKey, 'processed');

              case 2:
                nameAccount = _context.sent;

                if (nameAccount) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Invalid name account provided');

              case 5:
                res = borsh_1.deserializeUnchecked(this.schema, NameRegistryState, nameAccount.data);
                res.data = (_a = nameAccount.data) === null || _a === void 0 ? void 0 : _a.slice(this.HEADER_LEN);
                return _context.abrupt("return", res);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve(_x, _x2) {
        return _retrieve.apply(this, arguments);
      }

      return retrieve;
    }()
  }]);

  return NameRegistryState;
}();

exports.NameRegistryState = NameRegistryState;
NameRegistryState.HEADER_LEN = 96;
NameRegistryState.schema = new Map([[NameRegistryState, {
  kind: 'struct',
  fields: [['parentName', [32]], ['owner', [32]], ['class', [32]]]
}]]);